import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=669c8541&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/tododetail.css?vue&type=style&index=0&id=669c8541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c8541",
  null
  
)

export default component.exports